<template>
    <div class="hybrid-help">
        <h2>准备工作</h2>
        <p>在您使用该功能前，您需要完成以下准备工作：</p>
        <ul>
            <li>
                <p>确认您需要鉴别的物种。<br />
                    品种鉴别只针对金针菇、真姬菇和刺芹侧耳（杏鲍菇）的分析结果是可靠的，如上传其他物种测序数据，则分析结果会有误差。
                </p>
            </li>
            <li>
                <p>
                    请准备好您的二代测序数据。
                </p>
            </li>
        </ul>
        <h2>步骤一：选择物种</h2>
        <p>点击下拉框，选择您需要鉴别的物种，默认为金针菇。</p>
        <el-image
            style="width: 100%; height: 50%"
            :src="mnp_step1"
            :preview-src-list="mnp_src_step1"
        >
        </el-image>
        <h2>步骤二：输入用户名</h2>
        <p>请输入您的用户名，以便于后续与您联系。（此项为必填项）</p>
        <el-image
            style="width: 100%; height: 50%"
            :src="mnp_step2"
            :preview-src-list="mnp_src_step2"
        >
        </el-image>
        <h2>步骤三：输入邮箱</h2>
        <p>分析结果将发送至您的邮箱，请务必保证您的邮箱地址正确。（此项为必填项）</p>
        <el-image
            style="width: 100%; height: 50%"
            :src="mnp_step3"
            :preview-src-list="mnp_src_step3"
        >
        </el-image>
        <h2>步骤四：上传双端二代测序数据</h2>
        <p>请上传您的双端二代测序数据。（此项为必填项）</p>
        <el-image
            style="width: 100%; height: 50%"
            :src="mnp_step4"
            :preview-src-list="mnp_src_step4"
        >
        </el-image>
        <h2>步骤五：提交测序数据</h2>
        <p>
            点击提交按钮，文件开始上传，在文件上传过程中切勿关闭页面，切勿关闭浏览器。<br/><br/>
            文件上传成功，会有上传成功提示，数据分析完成后，分析结果我们会以邮件的形式通知您，请注意查收。
        </p>
        <el-image
            style="width: 100%; height: 50%"
            :src="mnp_step5"
            :preview-src-list="mnp_src_step5"
        >
        </el-image>
    </div>
</template>

<script>
import mnp_step1 from '../assets/mnp_identify1.jpg'
import mnp_step2 from '../assets/mnp_identify2.jpg'
import mnp_step3 from '../assets/mnp_identify3.jpg'
import mnp_step4 from '../assets/hybrid_identify4.jpg'
import mnp_step5 from '../assets/hybrid_identify5.jpg'
import mnp_step6 from '../assets/mnp_identify6.jpg'
import mnp_step7 from '../assets/mnp_identify7.jpg'
export default {
    name: "Hybrid_help",
    data () {
        return {
            mnp_step1,
            mnp_src_step1: [mnp_step1],
            mnp_step2,
            mnp_src_step2: [mnp_step2],
            mnp_step3,
            mnp_src_step3: [mnp_step3],
            mnp_step4,
            mnp_src_step4: [mnp_step4],
            mnp_step5,
            mnp_src_step5: [mnp_step5, mnp_step6, mnp_step7],
        }
    }
}
</script>

<style lang="scss" scoped>
.hybrid-help {
    padding: 16px;
    h2 {
        margin: 6px;
    }
}
</style>

